import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const alsConfig: TSPConfig = {
  key: 'als',
  name: 'ALS',
  category: TSPCategory.API_KEY,
  helpText: (
    <>
      <p>Connect to ALS by entering your API key.</p>
      <p>
        You can find your API key in your ALS dashboard under Settings → API
        Access.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default alsConfig;
